var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DashboardType } from '@/domain/usecases';
export const InitialCounters = {
    counter_accepts: 0,
    counter_denials: 0,
    counter_notifies: 0,
    counter_total_request: 0
};
export class DashboardHandler {
    constructor(remotes) {
        this.remotes = remotes;
    }
    getMetabaseDashboardLink() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const params = {
                    dashboard_type: DashboardType.OVERVIEW
                };
                return yield this.remotes.dashboardMetabase.getMetabaseLink(params);
            }
            catch (e) {
                return {
                    error: true
                };
            }
        });
    }
    getMetabaseReportingLink() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const params = {
                    dashboard_type: DashboardType.REPORTING
                };
                return yield this.remotes.dashboardMetabase.getMetabaseLink(params);
            }
            catch (e) {
                return {
                    error: true
                };
            }
        });
    }
    getMetabaseBillingLink(monthNumberAsString, yearAsString) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const params = {
                    dashboard_type: DashboardType.BILLING,
                    month: monthNumberAsString,
                    year: yearAsString
                };
                return yield this.remotes.dashboardMetabase.getMetabaseLink(params);
            }
            catch (e) {
                return {
                    error: true
                };
            }
        });
    }
}
